import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

const MATCH_CONFIG = {
  strong: {
    label: 'Strong',
    color: 'text-emerald-700',
    bg: 'bg-emerald-100',
    bar: 'from-emerald-400 to-emerald-500',
    width: '100%',
  },
  partial: {
    label: 'Partial',
    color: 'text-amber-700',
    bg: 'bg-amber-100',
    bar: 'from-amber-400 to-amber-500',
    width: '66%',
  },
  weak: {
    label: 'Weak',
    color: 'text-orange-700',
    bg: 'bg-orange-100',
    bar: 'from-orange-400 to-orange-500',
    width: '33%',
  },
  not_found: {
    label: 'Not Found',
    color: 'text-gray-500',
    bg: 'bg-gray-100',
    bar: 'from-gray-300 to-gray-400',
    width: '5%',
  },
};

function CriterionResultCard({ criterion }) {
  const [expanded, setExpanded] = useState(false);

  const match = criterion.match || 'not_found';
  const config = MATCH_CONFIG[match] || MATCH_CONFIG.not_found;

  return (
    <div className="group border border-gray-100 rounded-lg hover:border-gray-200 transition-colors">
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="w-full text-left px-3 py-2.5 flex items-start gap-2.5"
      >
        <div className="flex-1 min-w-0">
          <p className="text-[13px] font-medium text-gray-900 leading-snug">
            {criterion.criterionText || criterion.text}
          </p>
          <div className="mt-1.5 flex items-center gap-2">
            <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full bg-gradient-to-r ${config.bar} transition-all`}
                style={{ width: config.width }}
              />
            </div>
            <span
              className={`flex-shrink-0 text-[11px] font-semibold px-1.5 py-0.5 rounded ${config.bg} ${config.color}`}
            >
              {config.label}
            </span>
          </div>
          {criterion.evidence && match !== 'not_found' && (
            <p className="mt-1.5 text-[11px] text-gray-600 italic leading-snug line-clamp-2">
              &ldquo;{criterion.evidence}&rdquo;
            </p>
          )}
        </div>
        <span className="flex-shrink-0 mt-0.5 text-gray-400">
          {expanded ? (
            <ChevronUpIcon className="h-4 w-4" />
          ) : (
            <ChevronDownIcon className="h-4 w-4" />
          )}
        </span>
      </button>

      {expanded && criterion.reasoning && (
        <div className="px-3 pb-2.5 pt-0 border-t border-gray-50">
          <p className="text-xs text-gray-600 leading-relaxed">{criterion.reasoning}</p>
        </div>
      )}
    </div>
  );
}

export default CriterionResultCard;
